import { render, staticRenderFns } from "./ReceiptLogUnitDetail.vue?vue&type=template&id=63fa7caa"
import script from "./ReceiptLogUnitDetail.vue?vue&type=script&lang=js"
export * from "./ReceiptLogUnitDetail.vue?vue&type=script&lang=js"
import style0 from "./ReceiptLogUnitDetail.vue?vue&type=style&index=0&id=63fa7caa&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports